module.exports = __webpack_public_path__ + "img/cart_img.a42bdcc9.svg";